import { render } from "./Attach.vue?vue&type=template&id=06fe0f8b"
import script from "./Attach.vue?vue&type=script&lang=js"
export * from "./Attach.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Attach.vue"]])

export default __exports__